function GetIndexFromSchema(schemaName, schema) {
    for (let x = 0; x < schema.length; x++)
        if (schemaName == schema[x].name) return x;
    
    return -1;
}

export { GetIndexFromSchema };